/**
 * Mapping des IDS de skins (contrat back/front) → options du moteur `tano()`.
 * Les ids viennent de l'API (skin_plumage / skin_accessoire / skin_aura, skins_debloques).
 * Un id inconnu/absent → ignoré (base Forêt).
 */

// Plumage (XP) — Forêt = base (défauts du moteur).
export const TANO_PLUMAGE = {
  foret: {},
  bronze: { body: '#D98F4E', head: '#9A5C2C', cap: '#6E3F1C', wing: '#B0703A', tail: '#6E3F1C', belly: '#FBEAD6', crest: '#FFC078', beak: '#5A3818' },
  argent: { body: '#CFE0EC', head: '#7E94A4', cap: '#566A78', wing: '#A4BACA', tail: '#566A78', belly: '#FFFFFF', crest: '#7FD4FF', beak: '#46555E', browCol: 'rgba(40,55,70,.55)' },
  or: { body: '#FFD24A', head: '#D69A1E', cap: '#A8760E', wing: '#F0B838', tail: '#A8760E', belly: '#FFF6D6', crest: '#FFE9A8', beak: '#6E5210', halo: '#FFE08A', browCol: 'rgba(90,60,10,.6)' },
  cosmos: { body: '#6D7CFF', head: '#3946A3', cap: '#20276E', wing: '#4C57C8', tail: '#20276E', belly: '#EEF0FF', crest: '#FFB938', sparkle: true, halo: '#FFB938' },
};

// Accessoires (étoiles).
export const TANO_ACCESSOIRE = {
  lunettes: { glasses: true },
  echarpe: { scarf: '#29B6E8' },
  chapeau: { hat: 'paille' },
  casque: { hat: 'casque' },
  couronne: { hat: 'couronne' },
};

// Auras (flamme).
export const TANO_AURA = {
  etincelle: { sparkle: true },
  flamme: { flammeAura: true },
  halo: { haloArdent: true },
  anneau: { ring: true },
  braise: { ring: true, braiseHat: true },
};

/**
 * Rendu ROBOT (image webp unique + overlays) : mêmes ids API que le moteur
 * SVG, mais le plumage devient un FILTRE CSS sur l'image (la coque blanche
 * reste blanche, seules les lueurs bleues changent de teinte) + la couleur
 * des lueurs de l'écran-visage assortie. Valeurs de départ, tuning en recette.
 * Base robot = lueurs bleu cyan (~197°).
 */
// Teintes de la coque : on BLANCHIT d'abord (l'asset tire sur le gris-vert :
// brightness+contrast en tête de chaîne), puis sépia FORT → hue-rotate →
// saturation ×3+ pour des couleurs franches. La lueur du visage/néons est
// assortie. Ordre des filtres significatif (blanchir avant de teinter).
export const TANO_ROBOT_FILTRES = {
  // lueurVisage (optionnel) : couleur des yeux/bouche si différente des néons
  // d'armure — en Néon, visage BLANC pour ne pas se confondre avec les
  // lunettes cyan (accessoire de la même teinte que la lueur de base).
  foret: { filtre: 'brightness(1.09) contrast(1.04) sepia(.32) hue-rotate(168deg) saturate(3.6)', lueur: '#38C6FF', lueurVisage: '#FFFFFF' },
  // Bronze SOMBRE et cuivré (tire vers le brun-roux) vs or CLAIR et éclatant
  // (jaune brillant) : c'est la luminosité qui les sépare, pas que la teinte.
  bronze: { filtre: 'brightness(.86) contrast(1.14) sepia(.9) hue-rotate(-28deg) saturate(2.6)', lueur: '#E8712B' },
  argent: { filtre: 'grayscale(.55) brightness(1.16) contrast(1.09)', lueur: '#E8F4FF' },
  or: { filtre: 'brightness(1.15) contrast(1.02) sepia(.95) hue-rotate(-2deg) saturate(3.8)', lueur: '#FFD700' },
  cosmos: { filtre: 'brightness(1.02) contrast(1.06) sepia(.72) hue-rotate(200deg) saturate(3.6)', lueur: '#A87BFF' },
};

/**
 * Compose les options `tano()` à partir des ids équipés + un mood.
 * @param {{plume?:string, acc?:string, aura?:string, mood?:string}} sel
 */
export const buildTanoOptions = ({ plume, acc, aura, mood = 'idle' } = {}) => ({
  ...(TANO_PLUMAGE[plume] || TANO_PLUMAGE.foret),
  ...(acc ? TANO_ACCESSOIRE[acc] : null),
  ...(aura ? TANO_AURA[aura] : null),
  mood,
});
